export default __webpack_public_path__ + "static/media/lock_opn_icon.11036b09.svg";